import { defSimpleUnit, defAlias, defBaseUnit } from '../registry';

export const massUnits = [
  // SI units
  defBaseUnit('kilogram'),
  defSimpleUnit('gram', 'kilogram', 1e-3),
  defSimpleUnit('microgram', 'kilogram', 1e-9),
  defSimpleUnit('milligram', 'kilogram', 1e-6),

  defSimpleUnit('tonne', 'kilogram', 1e3),
  defSimpleUnit('kilotonne', 'kilogram', 1e6),
  defSimpleUnit('megatonne', 'kilogram', 1e9),
  defSimpleUnit('gigatonne', 'kilogram', 1e12),

  // US customary system definitions, taken from
  // https://www.nist.gov/system/files/documents/2016/11/10/hb44-2017-web_final.pdf
  // Appendix C
  defSimpleUnit('ounce', 'kilogram', 0.028349523125),
  defSimpleUnit('pound', 'kilogram', 0.45359237),
  defSimpleUnit('long_ton', 'pound', 2240),
  defSimpleUnit('short_ton', 'pound', 2000),
  defSimpleUnit('stone', 'pound', 14),
  defSimpleUnit('grain', 'pound', 1 / 7000),
  defSimpleUnit('dram', 'grain', 27 + 11 / 32),

  // Misc
  defSimpleUnit('carat', 'kilogram', 0.0002),
];

defAlias('kg', 'kilogram');
defAlias('g', 'gram');
defAlias('lb', 'pound');
defAlias('mg', 'milligram');
defAlias('mcg', 'microgram');
defAlias('megagram', 'tonne');
defAlias('tonnes', 'tonne');
defAlias('ton', 'short_ton');
defAlias('tons', 'short_ton');
